/**
 * Detect DIY / placeholder payment-mark SVGs for GoPay matrix §14 Fail UI.
 * Licensed official assets must not use RPAPP_PAYMENT_MARK_PLACEHOLDER or
 * text-only brand doodles (`<text>` + VISA/MC/… patterns).
 */
const PLACEHOLDER_COMMENT = /RPAPP_PAYMENT_MARK_PLACEHOLDER/i;

const TEXT_PLACEHOLDER =
  /<text\b[^>]*>[\s\S]{0,240}?(VISA|MASTERCARD|MASTER\s*CARD|SECURE|ID\s*CHECK|GOPAY|GoPay)/i;

export function isUnlicensedPaymentMarkSvg(svgText: string): boolean {
  const body = svgText.trim();
  if (body.length === 0) {
    return true;
  }
  if (PLACEHOLDER_COMMENT.test(body)) {
    return true;
  }
  if (TEXT_PLACEHOLDER.test(body)) {
    return true;
  }
  return false;
}
